import React, { useContext, useState } from "react";
import axios from "axios";
import Email from "common/EmailTomoScore";
import { BreakpointContext } from "components/common";
import { isValidEmail } from "@tomocredit/common-fe/utils/validation";
import { LEAD_SOURCES } from "@tomocredit/common-fe/consts/consts";
import {
  currMobileBrowserAccepted,
  fromWebview,
  isMobile,
  isTomoEmail,
  referralParam,
  totalUriParams,
  utmParams,
} from "utils/userAgentInfo";
import SignupConfirmationModal from "common/SignupConfirmationModal";

const LandingForm = () => {
  const { isBelow } = useContext(BreakpointContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [modalState, setModalState] = useState("");

  const sendOldEmailVerification = !!(
    (isMobile() && (utmParams.source || !currMobileBrowserAccepted())) ||
    fromWebview
  );

  const handleSubmit = async (email) => {
    if (loading) {
      return;
    }
    setError(null);
    if (!email) {
      setError("Email address is required");
      return;
    }
    if (!isValidEmail(email)) {
      setError("Invalid email address");
      return;
    }
    setLoading(true);

    if (!sendOldEmailVerification && isTomoEmail(email)) {
      window.location.replace(
        `${process.env.REACT_APP_DOMAIN}/register/basicinfo${
          totalUriParams || "?"
        }&user=${email}`,
      );
      return;
    }

    try {
      const userPayload = {
        withReferralCode: referralParam,
        sendOldEmailVerification,
        userId: email,
        utm: utmParams,
        source: LEAD_SOURCES.KOSMOFI_LANDING,
      };
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/users/newUserFromLanding`,
        userPayload,
      );
      setModalState("success");
    } catch (err) {
      setError("Could not communicate with server. Please try again later");
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-black">
      <p
        className="font-bold"
        // eslint-disable-next-line no-nested-ternary
        style={{ fontSize: isBelow("sm") ? 24 : isBelow("lg") ? 36 : isBelow("xl") ? 40 : 68 }}
      >
        <span className="px-2">The Card For</span> <br />
        <span className="bg-boost-primary-50 rounded py-1 px-2">
          Business Owners
        </span>
      </p>
      <p className="mt-3 text-lg lg:pr-6">
        Built and designed for immigrant business owners and freelancers.
      </p>
      <div className="mt-10">
        <p className="font-bold text-base">Sign up to learn more</p>
        <Email
          buttonText="Sign up"
          handleSubmit={handleSubmit}
          componentClassName="flex-col md:flex-row space-y-4 md:space-y-0 mt-2"
          inputClassName="w-full rounded-md md:rounded-r-none border border-neutral-500 md:border-r-0"
          buttonClassName="w-full md:w-auto py-2 text-white rounded-md md:rounded-l-none font-semibold bg-black-bg hover:bg-neutral-600 active:bg-neutral-700 px-4 border border-black-bg hover:border-neutral-600 active:border-neutral-700"
        />
        {error && (
          <p className="text-sm text-red-500 text-left mt-1">{error}</p>
        )}
        {modalState && (
          <SignupConfirmationModal
            closeModal={() => setModalState("")}
            modalState={modalState}
          />
        )}
      </div>
    </div>
  );
};

export default LandingForm;
